import React from 'react';
import { Grid, Paper } from '@mui/material';

import { UserSelected } from 'components/UserSelected/UserSelected';
import type { Employee } from 'containers/CommunityPage/EmployeeSearch/UserMultiSelect';

export type SelectedUserListProps = {
  users: Employee[];
  removeUser: (userId: string) => void;
};

export const SelectedUserList = ({ users, removeUser }: SelectedUserListProps): JSX.Element => (
  <Paper variant="outlined" style={{ padding: 4 }}>
    <Grid container spacing={1}>
      {users.map((user) => (
        <Grid item xs={12} sm={6} key={user.id}>
          <UserSelected user={user} removeMember={removeUser} />
        </Grid>
      ))}
    </Grid>
  </Paper>
);
